module.exports = __webpack_public_path__ + "static/media/assurant.4e6c00bd.webp";